export interface HeaderProps {
  /** The loan officer, not the borrower — this reassures the borrower whose
   *  request this is. Branding here is the lender's, per tenant. */
  officerName: string;
}

function initials(name: string) {
  return name
    .split(" ")
    .map((part) => part[0] ?? "")
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function Header({ officerName }: HeaderProps) {
  return (
    <header className="flex shrink-0 items-center justify-between border-b border-border bg-surface px-4 py-3">
      <div className="flex items-center gap-2">
        <VerityMark />
        <span className="text-lg font-extrabold tracking-tight">
          Paper<span className="text-verity-600">Verity</span>
        </span>
      </div>

      <div className="flex items-center gap-2.5">
        <span className="text-sm font-bold">{officerName}</span>
        <span
          aria-hidden
          className="grid size-9 place-items-center rounded-lg bg-portal-ink text-xs font-bold text-white"
        >
          {initials(officerName)}
        </span>
      </div>
    </header>
  );
}

export function VerityMark({ className = "size-6" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H9l-6 4V6Z"
        fill="var(--color-verity-600)"
      />
      <circle cx="8.5" cy="10" r="1.25" fill="white" />
      <circle cx="12" cy="10" r="1.25" fill="white" />
      <circle cx="15.5" cy="10" r="1.25" fill="white" />
    </svg>
  );
}
